import { useSortable } from "@dnd-kit/sortable";
import { CSS } from '@dnd-kit/utilities';

interface SortableTileProps {
    id?: string;
    className?: string;
    children: React.ReactNode;
}

export function SortableTile({ id, className, children }: SortableTileProps) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({ id: id ?? "" });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.4 : 1,
    };

    const dragHandleProps = { ...attributes, ...listeners }

    return (
        <div ref={setNodeRef} style={style} className={`${className} ${isDragging ? 'dragging' : ''}`}>

            <div className={`dashboard-tile p-3 border rounded h-100`}>
                <div className="drag-handle" {...dragHandleProps}>
                    <i className="bi bi-grip-horizontal"></i>
                </div>
                {children}
            </div>
        </div>
    );
}